import {API_HOST, API_ROOT, http} from "./http";
import ui from "./ui";
import {handleTokenErrors} from "../state/modules/errors";

/**
 * Resolves a scanned barcode and calls the matching handler.
 *
 * Shared by the visible BarcodeScanner and the hidden BarcodeListener on the cart
 * index, so a scan is dispatched the same way wherever it comes from.
 */
export function resolveBarcode(barcode, options = {}) {
    const {
        list = 'releases',
        defaultValues = null,
        showErrors = true,
        onLoadingChange = () => {},
        handlers = {},
    } = options;

    const call = (name, ...args) => {
        if (handlers[name]) {
            handlers[name](...args);
        }
    };

    if (defaultValues && defaultValues[barcode] && list === 'releases') {
        call('onReleaseFound', defaultValues[barcode]);
        return;
    }

    if (defaultValues && defaultValues[barcode] && list === 'orders') {
        call('onOrderFound', defaultValues[barcode]);
        return;
    }

    if (list === 'releases') {
        if (barcode === 'MM-2ND-HAND') {
            call('onSecondHand');
            return;
        }
        else if (barcode === 'MM-BXL-STOCK') {
            call('onBxlStock');
            return;
        }
        else if (barcode === 'MM-PLASTIC-BAG') {
            call('onPlasticBag');
            return;
        }
    }

    onLoadingChange(true);

    if (list === 'releases') {
        http.get(API_HOST + API_ROOT + 'carts/findbybarcode', true, {barcode: barcode})
            .then(response => {
                let result = response.result;
                let type = result.type;
                let item = result.item;

                if (type === 'release') {
                    if (Array.isArray(item)) {
                        call('onMultipleReleasesFound', item, barcode);
                    }

                    if (! Array.isArray(item)) {
                        call('onReleaseFound', item);
                    }
                }

                if (type === 'product') {
                    if (! Array.isArray(item)) {
                        call('onProductFound', item);
                    }
                }

                if (type === 'giftcard') {
                    if (! Array.isArray(item)) {
                        call('onGiftcardFound', item);
                    }
                }

                if (type === 'custom-product-type') {
                    if (! Array.isArray(item)) {
                        call('onCustomProductTypeFound', item);
                    }
                }

                onLoadingChange(false);
            })
            .catch(error => {
                if (error.message === 'item_not_found') {

                    call('onReleaseNotFound', barcode);

                    if (showErrors) {
                        ui.notify('Release/Product/Giftcard not found', 'error');
                    }

                    onLoadingChange(false);
                }
            })
            .catch(error => handleTokenErrors(error));
    }

    if (list === 'orders') {
        http.get(API_HOST + API_ROOT + 'orders/findbybarcode', true, {barcode: barcode})
            .then(response => {
                let result = response.result;

                if (result.length > 1) {
                    call('onMultipleOrdersFound', result, barcode);
                }

                if (result.length === 1) {
                    call('onOrderFound', result);
                }

                onLoadingChange(false);
            })
            .catch(error => {
                if (error.message === 'order_not_found') {
                    call('onOrderNotFound', barcode);

                    if (showErrors) {
                        ui.notify('Order not found', 'error');
                    }

                    onLoadingChange(false);
                }
            })
            .catch(error => handleTokenErrors(error));
    }
}
